import { defineStore } from 'pinia';
import { axios } from '@boot/axios.js';
/**
 * Return the default state for the sensors store.
 */
function getDefaultState() {
    return {
        sensors: {},
        assetsWithSensors: new Set()
    };
}
/**
 * Store for managing sensor-related data.
 */
export const useSensorsStore = defineStore('sensors', {
    state: () => getDefaultState(),
    getters: {
        /**
         * Get sensors running on an asset by asset id.
         */
        getSensors: state => {
            return (id) => {
                const assetId = Number(id);
                if (state.sensors[assetId]) {
                    return state.sensors[assetId];
                }
                else {
                    return null;
                }
            };
        },
        /**
         * Check if an asset is connected to at least one sensor.
         */
        isAssetConnectedToSensor: state => {
            return (assetId) => {
                return state.assetsWithSensors.has(Number(assetId));
            };
        }
    },
    actions: {
        /**
         * Reset store state.
         */
        resetState() {
            this.$reset();
        },
        /**
         * Get sensors connected to Asset.
         */
        async loadSensorsAction(assetId) {
            const sensors = [];
            try {
                const response = await axios.get(`/sensors/?asset=${assetId}`);
                response.data['results'].forEach((result) => {
                    sensors.push({
                        asset: result.asset,
                        device: result.device,
                        id: result.id,
                        location: result.location,
                        sensor_id: result.sensor_id,
                        sensor_type: result.sensor_type,
                        uuid: result.uuid,
                        is_enabled: result.is_enabled
                    });
                });
                // Store sensors
                const id = Number(assetId);
                this.sensors[id] = sensors;
                return { sensors };
            }
            catch (error) {
                console.error('Failed to fetch sensors data due to: ', error);
                throw error;
            }
        },
        /**
         * Add sensors to an asset.
         */
        addSensorsAction(assetId, sensors) {
            const id = Number(assetId);
            this.sensors[id] = sensors;
        },
        /**
         * Add a single sensor to an asset.
         */
        addSensorAction(assetId, sensor) {
            const id = Number(assetId);
            if (this.sensors[id]) {
                this.sensors[id] = [...this.sensors[id], { ...sensor }];
            }
            else {
                this.sensors[id] = [{ ...sensor }];
            }
        },
        /**
         * Store assets connected to a device.
         */
        addAssetsWithSensorAction(assets) {
            assets.forEach(asset => {
                this.assetsWithSensors.add(asset.id);
            });
        }
    }
});
